import React,{useState} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';


function AnswerField(props){
   
    let answers = props.answers
    
    const [value,setVal] = useState(props.data!=null?props.data:answers[0])
    
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       
  
        props.handler(e)

    }
    const event_name = props.name.toString()
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index}>{answer}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }

AnswerField.defaultProps ={
    useScore:false,
    data:null
}

function getAnswerIndex(array,answer){
    
    for (var i =0; i<array.length;i++){
        
       
            var index = array[i].indexOf(answer);
            if(index> -1){
                return i;
            }
        
        
        
    }
}
function AnswerField_Score(props){
    const event_name = props.name.toString()
    let answers = props.answers
   var scoreIndex;
    if(props.data!=null){
        scoreIndex =getAnswerIndex(answers,props.data)
    }
    
    const [changed,triggerChange] = useState(props.data!=null?true:false)
    const [previous,setPrevious] = useState(props.data!=null?answers[scoreIndex][1]:0)
    const [value,setVal] = useState(props.data!=null?props.data:answers[0][0])
   
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       if (changed){
            props.score(-previous)
            props.score(parseInt(answers[e.target.selectedIndex][1]))
            setPrevious(parseInt(answers[e.target.selectedIndex][1]))

       }
       else{
      
            
            setPrevious(parseInt(answers[e.target.selectedIndex][1]))
            triggerChange(true)
            props.score(parseInt(answers[e.target.selectedIndex][1]))
            
        }
        props.handler(e)
        
    }
    
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index} score={answer[1]}>{answer[0]}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }

AnswerField_Score.defaultProps ={
    data:null
}

class Questions_Table extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0}
        
    }
    Scoring = async (val)=> {
       
        
        if (!isNaN(val)){
             await this.setState((prevState) => 
                         ({
                             ...prevState,
                             score:prevState.score + (val)
 
                         })
                         
             )
         }
         
     }
    onChange = async (event,score_val)=>{
        const {name,value} = event.target
        await this.setState((prevState)=>({
            ...prevState,
            [name]: value,
            score:prevState.score + score_val
        }))
        
     }
    // componentDidUpdate(prevProps,prevState){
    //     if (prevState != this.state){
    //         this.props.handler(this.props.fieldName,this.state)
    //     }
    // }
    render(){
        let questions = this.props.questions
        return(
            <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                <thead>
                        <tr>
                            
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                </thead>
                <tbody>
                    {questions.map((question,index)=>(
                        
                        <tr key={index}>
                           {("index" in question)?<td>{question.index}. {question.title}</td>:<td>{index+1}. {question.title}</td>}
                           {("answers" in question)? <td width={400}> {(this.props.score )
                                ? 
                                <AnswerField_Score name={question.name} handler={this.props.handler} data={this.props.data!=null?this.props.data[question.name]:null} disabled={this.props.disabled} answers={question.answers} fieldName={this.props.fieldName} score={this.props.scoreFunc}/>
                                
                                :<AnswerField name={question.name} handler={this.props.handler} data={this.props.data!=null?this.props.data[question.name]:null} disabled={this.props.disabled} answers={question.answers} fieldName={this.props.fieldName}/>}
                            </td>:<td></td>}
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    }
    
}
Questions_Table.defaultProps = {
    Scoring:false,
    score:null,
    data:null
}


export default Questions_Table;